module.exports = __webpack_public_path__ + "img/empty.4e8edc4d.svg";